import { render, staticRenderFns } from "./FreeModalComponent.vue?vue&type=template&id=33d25494&scoped=true&"
import script from "./FreeModalComponent.vue?vue&type=script&lang=js&"
export * from "./FreeModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./FreeModalComponent.vue?vue&type=style&index=0&id=33d25494&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d25494",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BImg, BRow, BButton, BLink, BCol, BAvatar, BContainer, BModal} from 'bootstrap-vue'
    installComponents(component, {BImg, BRow, BButton, BLink, BCol, BAvatar, BContainer, BModal})
    

export default component.exports